function calculatedPercentage(part, whole) {
    let percentage = part / whole * 100;
    return percentage;
}

export default calculatedPercentage